<template>
  <div class="ui segments">

    <div class="ui segment">
    <div class="ui breadcrumb">
    <router-link :to="{name:'home'}" class="section">Sākums</router-link>
    <span class="divider">/</span>
    <router-link :to="{name:'autoship'}" class="section">Mani Autoship pasūtījumi</router-link>
    <span class="divider">/</span>
    <div class="active section">Rediģēt</div>
  </div>


 </div>

 <div class="ui segment">

   <skipped-goods-warning v-bind:storeStatus="storeStatus"></skipped-goods-warning>

   <div class="ui warning icon message" v-if="autoship.status == 0" >
     <i class="info circle icon"></i>
     <div class="content">
       <div class="header">
         Informācijai
       </div>
       <p>Autoship ir apturēts, lai atjaunotu automātisku pasūtījumu piegādāšanu, lūdzu samainiet autoship statusu!</p>
     </div>
   </div>

  <div class="ui form">
    <h2 class="ui dividing header">AutoShip pasūtījums</h2>
    <div class="four fields">
        <div class="field">
          <label>Nosaukums</label>
          <input type="text" placeholder="Nosaukums" :value="autoship.autoship_name" @change="updateAutoship('autoship_name', $event.target.value)">
        </div>
        <div class="field">
            <label>&nbsp;</label>
          <div class="ui toggle checkbox">
            <input type="checkbox" :checked="autoship.status == 1" number value="1" @change="updateAutoship('status', $event.target.value)">
            <label>AutoShip statuss - <span v-if="autoship.status == 1">Aktīvs</span><span v-else>Neaktīvs</span></label>
          </div>
        </div>

    </div>
    <div class="four fields">

        <div class="field">
            <label>&nbsp;</label>
          <div class="ui toggle checkbox">
            <input type="checkbox" :checked="autoship.pause == 1" number value="1" @change="updatePause($event.target.value)">
            <label>Uz laiku apturēt AutoShip</label>
          </div>
        </div>

        <div class="ui calendar field" id="stop_from" v-if="autoship.pause == 1">
          <label>Pārtraukt no</label>
          <div class="ui input left icon">
            <i class="calendar icon"></i>
            <input type="text" placeholder="Norādit datumu no" :value="autoship.pause_from" @change="updateAutoship('pause_from', $event.target.value)">
          </div>
        </div>

        <div class="ui calendar field" id="stop_till" v-if="autoship.pause == 1">
          <label>Pārtraukt līdz</label>
          <div class="ui input left icon">
            <i class="calendar icon"></i>
            <input type="text" placeholder="Norādit datumu līdz" :value="autoship.pause_to" @change="updateAutoship('pause_to', $event.target.value)">
          </div>
        </div>
    </div>

    <!-- second row -->
    <h3 class="ui dividing header">
      <i class="marker icon"></i>
      <div class="content">
        Piegādes informācija un regularitāte
      </div>
    </h3>
    <div class="two fields">
        <div class="field">
          <label>Adrese</label>
          <select class="ui fluid dropdown" @change="changeDeliveryAddress($event.target.value)">
                <option v-for="item in address" :value="item.id" :selected="item.id == autoship.address_id ? true:false">{{item.street}}<span v-if="item.house_no !=''">&nbsp;</span>{{item.house_no}}<span v-if="item.flat_no !=''">,&nbsp;</span>{{item.flat_no}}<span v-if="item.city_label !=''">,&nbsp;</span>{{item.city_label}}</option>
              </select>

        </div>
        <div class="field">
          <label>&nbsp;</label>
          <a @click="showDeliveryZones">Piegādes reģionu karte</a>

          <!-- delivery address zones -->

          <div class="ui modal" id="delivery-zone2">
            <i class="close icon"></i>
            <div class="image content">
              <div class="ui  image">
                <img src="https://api.memorywater.lv/img/documents/piegades-teritorija.png">
              </div>
            </div>

          </div>


<!-- end of delivery addres zones -->
        </div>
    </div>

    <!-- third row -->
    <div class="two fields">
        <div class="field">
          <label>Pasūtīšanas regularitāte</label>
          <select class="ui fluid dropdown" @change="updateAutoship('frequency', $event.target.value)" id="autoship_frequency">
            <option v-if="checkIfAvailableForAddress(1)" value="1" :selected="autoship.frequency == 1">Reizi nedēļā</option>
            <option v-if="checkIfAvailableForAddress(2)" value="2" :selected="autoship.frequency == 2">Reizi divās nedēļās</option>
            <option v-if="checkIfAvailableForAddress(3)" value="3" :selected="autoship.frequency == 3">Reizi trīs nedēļās</option>
            <option v-if="checkIfAvailableForAddress(4)" value="4" :selected="autoship.frequency == 4">Reizi četrās nedēļās</option>
            <option v-if="checkIfAvailableForAddress(5)" value="5" :selected="autoship.frequency == 5">Reizi piecās nedēļās</option>
            <option v-if="checkIfAvailableForAddress(6)" value="6" :selected="autoship.frequency == 6">Reizi sešās nedēļās</option>
            <option v-if="checkIfAvailableForAddress(7)" value="7" :selected="autoship.frequency == 7">Reizi septiņās nedēļās</option>
            <option v-if="checkIfAvailableForAddress(8)" value="8" :selected="autoship.frequency == 8">Reizi astoņās nedēļās</option>
          </select>
        </div>
    </div>

 <!-- forth row -->
 <div class="two fields">
   <div class="ui calendar field" id="start_date" >
     <label>Sākuma (nākamās piegādes) datums</label>
     <div class="ui input left icon">
       <i class="calendar icon"></i>
       <input type="text" placeholder="Norādit datumu no" :value="autoship.delivery_date">
     </div>
   </div>
 </div>

 <!-- goods row -->
 <h3 class="ui dividing header">
   <i class="shop icon"></i>
   <div class="content">
     Preces
   </div>
 </h3>





<div class="ui container">
  <div  class="ui attached segment" v-bind:class="{ loading: storeStatus.loading }">

    <div class="ui form">
      <!-- goods row -->
      <div v-if="itemsInCart>0" class="ui divided items">
        <div v-for="item in items" class="item">
          <div class="ui tiny image" @click="$router.push('/good/'+item.link)" style="cursor:pointer">
            <img  v-if="item.images[0]" :src="item.images[0].url" />
            <img  v-else :src="'https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_250,c_lfill/product/'+item.good_id+'.jpg'" />
          </div>
          <div class="content">

            <router-link :to="'/good/'+item.link"  class="header">{{item.name}}</router-link>
            <div class="meta">
              <div class="ui tag labels">
                <a class="ui custom_brown label">
                Cena: {{item.price_vat}} &euro;
              </a>
                <a v-if="item.bail>0" class="ui green label">
                Drošības nauda: {{item.bail}} &euro;
              </a>
              </div>
              <!--span class="cinema">Cena {{item.price_vat}} &euro; gab.<span v-if="item.bail>0">, Drošības nauda {{item.bail}} &euro;</span></span-->
            </div>
            <div class="description">
              <p>{{item.description}}</p>
            </div>
            <div class="extra">
              <button v-if="autoship.lock == 0" v-on:click="removeItem(item)" class="ui right floated grey icon button">
              <i class="right trash icon"></i>
            </button>
            <!--
              <div v-if="item.isrentable == 1" class="ui right floated inline fields">
                <label>Atgriezīšu: &nbsp; x </label>
                <div class="field">
                  <input type="text" placeholder="skaits" @keyup="updateCartItemReturn(item, $event.target.value)" :value="item.return" disabled style="width:70px" number>
                </div>
              </div>
            -->
              <div class="ui right floated inline fields">
                <label>Pasūtīšu: &nbsp; x </label>
                <div class="field">
                  <input type="text" :disabled="autoship.lock == 1" placeholder="skaits" @keyup="updateCartItemOrder(item, $event.target.value)" :value="item.order"  style="width:70px" number>
                </div>
              </div>

                <div v-for="badge in item.badges" class="ui label" :style="{ backgroundColor: '#'+badge.color, color: '#210404'}">{{badge.label}}</div>

            </div>
          </div>
        </div>
      </div>

      <div  v-if="autoship.lock == 0" class="ui container">
        <button @click="$router.push({name:'autoship-add-goods', params:{id:autoship.id, page:1}})" class="ui right floated green button">Pievienot preces</button>
        <div class="ui clearing hidden divider"></div>
      </div>

    </div>
  </div>

 <div class="ui clearing hidden divider"></div>
</div>

  </div>

</div>

<div class="ui secondary segment" v-if="itemsInCart > 0 ">
  <h3 class="ui dividing header">
    <i class="money icon"></i>
    <div class="content">
      Kopsavilkums
    </div>
  </h3>


  <div class="ui two column grid">
    <div class="row">
      <div class="ui column form">

            <div class="ui field">
              <label>Apmaksas veids</label>
              <select class="ui fluid dropdown" @change="updateAutoship('payment_type', $event.target.value)">
                <option value="3" :selected="autoship.payment_type == 3">Skaidrā saņemot preci</option>
                <option value="2" :selected="autoship.payment_type == 2">No konta</option>
                <option v-if="user.pay_later == 1" value="5" :selected="autoship.payment_type == 5">Pēcapmaksa</option>
              </select>
            </div>

        <div class="ui field">
            <label>Komentāri</label>
            <textarea rows="4" placeholder="Šeit ierakstītā piezime parādīsies pie katra pasūtījuma" :value="autoship.notes" @change="updateAutoship('notes', $event.target.value)"></textarea>
          </div>
      </div>
      <div class="column">
        <div style="float:right;" v-if="autoship.details">
          <div class="ui list" style="text-align:right; margin-top:30px">
            <div class="item"><b>Nākamā pasūtījuma summa:</b></div>
            <div class="item" v-if="autoship.details.water_goods_price_vat>0">Ūdens 18,9l: {{autoship.details.water_goods_price_vat}} &euro;</div>
            <div class="item" v-if="autoship.details.services_price_vat>0">Pakalpojums: {{autoship.details.services_price_vat}} &euro;</div>
            <div class="item" v-if="autoship.details.no_water_goods_price_vat>0">Citas preces: {{autoship.details.no_water_goods_price_vat}} &euro;</div>
            <div class="item" v-if="autoship.details.bail != 0" style="color:#E12F2E"><span id="bail" data-content="Turpiniet, ievadot piegādes datumu un pārbaudiet veikto pasūtījumu. Ņemiet vērā, ka par katru lietošanā esošo pudeli jāmaksā drošības nauda. Drošības nauda tiks atgriezta pēc tukšo pudeļu atdošanas">Drošības nauda: {{autoship.details.bail}} &euro;</span></div>
            <div class="item" v-if="autoship.details.deposit_amount != 0"><span id="deposit">Depozīts: {{autoship.details.deposit_amount}} &euro;</span></div>
			<div class="item" v-if="(autoship.details.extra_delivery != 0) && (autoship.details.water_goods_price_vat > 0)" style="color:#E12F2E"><span id="delivery" data-html="Degvielas piemaksa netiks pievienota, ja pasūtīsiet produktus par vismaz 25 EUR."><i class="info circle icon" data-html="Degvielas piemaksa netiks pievienota, ja pasūtīsiet produktus par vismaz 25 EUR."></i>Mainīgā degvielas piemaksa: {{autoship.details.extra_delivery}} &euro;</span></div>
			<div class="item" v-else-if="(autoship.details.extra_delivery != 0)" style="color:#E12F2E"><span id="delivery" data-html="Piegādes maksa netiks pievienota, ja pasūtīsiet produktus par vismaz 25 EUR.">Piegāde: {{autoship.details.extra_delivery}} &euro;</span></div>
            <div class="item"><b>Kopsumma: {{autoship.details.total_price_with_bail_and_vat}} &euro;</b></div>
            <div class="item" v-if="autoship.details.bonus>0" style="color:#21BA45"><span id="bonus_autoship" data-content="Par katru Memory Water 18,9l pasūtījumu jūs saņemat 2% bio un citu veselīgu produktu iegādei">Bonuss: + {{autoship.details.bonus}} &euro; </span></div>

          </div>
        </div>
      </div>
    </div>
    <div class="row">
        <div class="column"></div>
      <div class="column">

        <div class="ui right floated buttons">
        <button class="ui button" @click="$router.push({name:'autoship'})">Atpakaļ</button>
        <div v-if="autoship.lock ==0" class="or" data-text="vai"></div>
        <button v-if="autoship.lock ==0" class="ui custom_brown button" @click="processAutoShip()" :class="{ disabled: autoship.delivery_date == ''}" >Saglabāt</button>
        </div>

      </div>
    </div>
  </div>




    <div class="ui clearing hidden divider"></div>
</div>




  </div>

</template>

<script>

import SkippedGoodsWarning from './SkippedGoodsWarning';

export default {

  components:{
      'skipped-goods-warning': SkippedGoodsWarning
  },

 computed: {
   storeStatus() {
     return this.$store.state.autoShipStore.status
   },
   autoship() {
     return this.$store.state.autoShipStore.details;
   },
   user() {
     return this.$store.state.userStore.user
   },
   address() {
     return this.$store.state.addressStore.items
   },
   items() {
     return this.$store.state.autoShipStore.items
   },
   itemsInCart() {
     return this.$store.state.autoShipStore.items.length;

   },
 },


  activated(){

    var id = (this.$route.params.id) ? this.$route.params.id : 0;
    //load only once and if not matching so that page is not related when user goes to add goods page for autoship and change state in autoship form

    //if(this.autoship.id != id){

      this.$store.dispatch('loadAutoshipDetails',id).then((response) => {
        this.$store.dispatch('loadAutoshipItems', this.autoship.id);
        this.$store.dispatch('loadAddress').then(() => {
          this.activateCalendar(this.autoship.address_id);

          this.enablePopups();

        });

        this.activateOtherCalendars()
      }).catch((error) => {
        console.error('Cart was not loaded')
        //go back to previous page
        this.$router.push({
            name: 'autoship',
        });
      });
    //}
    //else {
    //  this.$store.dispatch('loadAddress').then(() => {
    //    this.activateCalendar(this.autoship.address_id);
    //  });
  //    this.activateOtherCalendars();
  //  }
  },


  watch: {
      "autoship": function() {
          this.enablePopups();
      }
  },


  methods:{


    enablePopups: _.debounce(function() {
        $('#bail').popup();
        $('#delivery').popup();
        $('#bonus_autoship').popup();
    }, 500),


      showDeliveryZones(){

        $('#delivery-zone2')
          .modal('show')
        ;

      },

      checkIfAvailableForAddress(frequency){
        var isVisible = true;

        //if address selected
        if(this.autoship && this.autoship.address_id && this.address && this.address.length > 0){
            //look up adddress by id
            var address = this.getSelectedAddress(this.autoship.address_id);

            //check if frequency is defined
            if(address && address.frequency > 0){
              //if yes then check if its equal or higher than required
              if(frequency == 1 && address.frequency == 1) isVisible = true;
              else if(frequency == 2 && (address.frequency == 1 || address.frequency == 2)) isVisible = true;
              else if(frequency == 3 && (address.frequency == 1 || address.frequency == 3)) isVisible = true;
              else if(frequency == 4 && (address.frequency == 1 || address.frequency == 2 || address.frequency == 4)) isVisible = true;
              else if(frequency == 5 && (address.frequency == 1 || address.frequency == 5)) isVisible = true;
              else if(frequency == 6 && (address.frequency == 1 || address.frequency == 2 || address.frequency == 3 || address.frequency == 6)) isVisible = true;
              else if(frequency == 7 && (address.frequency == 1 || address.frequency == 7)) isVisible = true;
              else if(frequency == 8 && (address.frequency == 1 || address.frequency == 2 || address.frequency == 4 || address.frequency == 8)) isVisible = true;
              else isVisible = false;
            }
            //not defined
            else{
              //return true
              isVisible = true;
            }
        }

        return isVisible;
      },

      activateOtherCalendars(){

        var today = new Date();

        var self = this;

        $('#stop_from').calendar({
          type: 'date',
          minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1),
          maxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 30),
          endCalendar: $('#stop_till'),
          firstDayOfWeek:1,
          touchReadonly:true,
           formatter: {
             date: function (date, settings) {

               if (!date) return '';
               var day = date.getDate();
               if (day < 10) { day = '0' + day; }
               var month = date.getMonth(); //settings.text.months[];
               month++
               if (month < 10) { month = '0' + month; }
               var year = date.getFullYear();
               return year + '-' + month + '-' + day;
             }
          },
          onChange: function (date, text) {

            var day = date.getDate();
            if (day < 10) { day = '0' + day; }
            var month = date.getMonth(); //settings.text.months[];
            month++
            if (month < 10) { month = '0' + month; }
            var year = date.getFullYear();
            var ymd = year + '-' + month + '-' + day;

            var updatedautoship = JSON.parse(JSON.stringify(self.autoship));

            updatedautoship.pause_from = ymd;

            self.$store.dispatch('updateAutoship', updatedautoship);

          },

        });
        $('#stop_till').calendar({
          type: 'date',
          maxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 130),
          startCalendar: $('#stop_from'),
          firstDayOfWeek:1,
          touchReadonly:true,
           formatter: {
             date: function (date, settings) {

               if (!date) return '';
               var day = date.getDate();
               if (day < 10) { day = '0' + day; }
               var month = date.getMonth(); //settings.text.months[];
               month++
               if (month < 10) { month = '0' + month; }
               var year = date.getFullYear();
               return year + '-' + month + '-' + day;
             }
          },
          onChange: function (date, text) {

            var day = date.getDate();
            if (day < 10) { day = '0' + day; }
            var month = date.getMonth(); //settings.text.months[];
            month++
            if (month < 10) { month = '0' + month; }
            var year = date.getFullYear();
            var ymd = year + '-' + month + '-' + day;

            var updatedautoship = JSON.parse(JSON.stringify(self.autoship));

            updatedautoship.pause_to = ymd;

            self.$store.dispatch('updateAutoship', updatedautoship);

          }
        });
      },
      loadAutoship(id){

          this.$store.dispatch('loadAutoshipDetails',id);

      },

      updateAutoship(field,value){

      //  this.$store.commit('UPDATE_AUTOSHIP_DETAILS_FIELD', [field,value]);
        var autoship = JSON.parse(JSON.stringify(this.autoship));

        if(field == 'status'){
          value = (autoship.status == 0) ? 1 : 0;
        }
        autoship[field] = value

        this.$store.dispatch('updateAutoship', autoship);
      },

      //when this changes we need to enable/disable calendars
      updatePause(value){

        var autoship = JSON.parse(JSON.stringify(this.autoship));
        value = (autoship.pause == 0) ? 1 : 0;
        autoship['pause'] = value;

        this.$store.dispatch('updateAutoship', autoship).then((response) => {
          //enable calendar
          if(value == 1){
            this.activateOtherCalendars();
          }
        }).catch((error) => {
          console.error('Autoship was not updated')
        });


      },

      processAutoShip(){

        //in additin update frequency as it might be changed without triggering changes
        var autoship = JSON.parse(JSON.stringify(this.autoship));
        autoship.frequency = $('#autoship_frequency').val();

        //first update then process
        this.$store.dispatch('updateAutoship', autoship).then((response) => {
          //if all ok then process
          this.$store.dispatch('processAutoship', autoship).then((response) => {
            this.$router.push({
              name: 'autoship',
            });
          }).catch((error) => {
            console.error('Autoship was not updated')
          });
        }).catch((error) => {
          console.error('Autoship was not updated')
        });



      },
	  
	  /* calendar logic */

      isDateDisabled(date, mode, addressId) {
          if (date) {
              var address = this.getSelectedAddress(addressId);
              if (!address) return true;
      
              //check if date is in the past + 1
              if(date <= new Date()){
                return true;
              }
              
              //check if there is restricted dates for address. If dates are in past then user will not be able to select any date!
              else if (address.allowed_dates != "") {
                  //add ";" in front of date string and when searching for ;d-m-yyyy. This is required
                  //to ensure that 5-12-2016 would not match with 15-12-2016
                  var dmy = ";" + date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
                  address.allowed_dates = ";" + address.allowed_dates;
                  if (address.allowed_dates && address.allowed_dates.indexOf(dmy) > -1) { //dates are passed in string format d-mm-yyyy,d-mm-yyyy
                      //return false;
                      
                      //days config override
                      var dm = ';' + date.getDate() + "-" + (date.getMonth() + 1) + ';';
                      if (address.forbidden_working_days != "" && address.forbidden_working_days.indexOf(dm) > -1) { //dates are passed in string format d-mm-yyyy,d-mm-yyyy
                          return true;
                      } else {
                          return false;
                      }
                  } else {
                      //return true;
                      
                      //days config override
                      var dm = ';' + date.getDate() + "-" + (date.getMonth() + 1) + ';';
                      if (date.getDay() == 0) {
                          if (address.allowed_weekends != "" && address.allowed_weekends.indexOf(dm) > -1) { //dates are passed in string format d-mm-yyyy,d-mm-yyyy
                              return false;
                          } else {
                              return true;
                          }
                      }
                  }
              } else { //check if weekend is allowed or working day disabled
                  var dm = ';' + date.getDate() + "-" + (date.getMonth() + 1) + ';';
                  // if day is Sunday then check if its allowed using allowed_weekends attribute
                  if (date.getDay() == 0) {
                      if (address.allowed_weekends != "" && address.allowed_weekends.indexOf(dm) > -1) { //dates are passed in string format d-mm-yyyy,d-mm-yyyy
                          return false;
                      } else {
                          return true;
                      }
                  } else { //if day is working day or Sat.day
                      //then check if its restricted
                      if (address.forbidden_working_days != "" && address.forbidden_working_days.indexOf(dm) > -1) { //dates are passed in string format d-mm-yyyy,d-mm-yyyy
                          return true;
                      } else {
                          return false;
                      }
                  }
              }
          }
      
          //in all other cases disable date
          return true;
      },
  
      getSelectedAddress(addressId){
      
        //copy object and find selected address
        var addressObject = JSON.parse(JSON.stringify(this.address));
      
      
        var index = addressObject.findIndex(o => o.id == addressId);
        if(index >=0){
          return addressObject[index]
        }
        else {
      
          return addressObject[0]
        }
      },
	  
      //small debounce due to render
      activateCalendar: _.debounce(function(addressId) {
        //get selected address, used later
        var address = this.getSelectedAddress(addressId);
      
        //check if next date is not disabled, if it is then try to get next available date
        //first convert yyyy-mm-dd to date
        var st = (this.autoship.delivery_date) ? this.autoship.delivery_date : '';
        var pattern = /(\d{2})\-(\d{2})\-(\d{4})/;
        var date = new Date(st.replace(pattern,'$1-$2-$3'));
        //check if not disabled
        if(this.autoship.delivery_date != "" && this.autoship.delivery_date != null && !this.isDateDisabled(date, '', addressId)){
          var nextDate = date;
          var nextDateOk = true;
        }
        //if disabled then pick up next available date
        else{
      
          var nextDate = new Date();
          var nextDateOk = false;
          var i;
      
          if (address.allowed_dates != "") {
      
            //check if any of next 90 days are within allowed dates
            for (i = 1; i < 90; i++) { //start with tomorrow
      
                  //increment
                  nextDate.setDate(nextDate.getDate() + 1);
                  var dmy = ";" + nextDate.getDate() + "-" + (nextDate.getMonth() + 1) + "-" + nextDate.getFullYear();
                  address.allowed_dates = ";"+address.allowed_dates;
                  //check if its within allowed_dates dates
      
                  if(address.allowed_dates.indexOf(dmy) > -1 && !this.isDateDisabled(nextDate, '', addressId)){
                      nextDateOk = true;
                      break;
                  }
            }
          }
      
          else {
            for (i = 1; i < 90; i++) { //start with tomorrow
      
                  nextDate.setDate(nextDate.getDate() + 1);
      
                  var dm = ';' + nextDate.getDate() + "-" + (nextDate.getMonth() + 1)  + ';'
      
      
                  //if weekend then check if its allowed
                  //only sundays
                  if (nextDate.getDay() == 0) {
      
      
                      if(address.allowed_weekends != "" && address.allowed_weekends.indexOf(dm) > -1) {
                          nextDateOk = true;
                          break;
                      }
                  }
                  //if working day then check that its not forbidden
      
                  else if(address.forbidden_working_days != "" && address.forbidden_working_days.indexOf(dm) == -1){
                      nextDateOk = true;
                      break;
                  }
      
      
            }
          }
        }
      
        //update date in autoship and calendar
      
          var day = nextDate.getDate();
          if (day < 10) { day = '0' + day; }
          var month = nextDate.getMonth(); //settings.text.months[];
          month++
          if (month < 10) { month = '0' + month; }
          var year = nextDate.getFullYear();
          var ymd = year + '-' + month + '-' + day;
      
         var deliveryDate = (nextDateOk) ? ymd : '';
      
          var updatedautoship = JSON.parse(JSON.stringify(this.autoship));
      
          updatedautoship.delivery_date = deliveryDate;
          updatedautoship.address_id = address.id;
          //if there is no data then set it on autoship object to prevent user from proceeding
          if(deliveryDate == '') this.$store.commit('SET_AUTOSHIP_DETAILS', updatedautoship);
          else this.$store.dispatch('updateAutoship', updatedautoship);
      
      
      
        var today = new Date();
      
        var self = this;
      
        $('#start_date').calendar({
          type: 'date',
          firstDayOfWeek:1,
          touchReadonly:true,
          maxDate:new Date(today.getFullYear(), today.getMonth()+3, today.getDate() + 1),
          minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1),
          /*
          //removed as it requires reinitiate calendar after store is reloaded
          text: {
               days: ['Sv.', 'P', 'O', 'T', 'C', 'P', 'S'],
               months: ['Janvāris', 'Februāris', 'Marts', 'Aprīlis', 'Maijs', 'Jūnijs', 'Jūlijs', 'Augusts', 'Septembris', 'Oktobris', 'Novembris', 'Decembris'],
             },
            */
         formatter: {
           date: function (date, settings) {
      
             if (!date) return '';
             var day = date.getDate();
             if (day < 10) { day = '0' + day; }
             var month = date.getMonth(); //settings.text.months[];
             month++
             if (month < 10) { month = '0' + month; }
             var year = date.getFullYear();
             return year + '-' + month + '-' + day;
           }
        },
              // is the given date disabled?
        isDisabled: function (date, mode) {
          return self.isDateDisabled(date, mode, addressId);
          if(!date) return true;
      
        },
        onChange: function (date, text) {
      
          var day = date.getDate();
          if (day < 10) { day = '0' + day; }
          var month = date.getMonth(); //settings.text.months[];
          month++
          if (month < 10) { month = '0' + month; }
          var year = date.getFullYear();
          var ymd = year + '-' + month + '-' + day;
      
          var updatedautoship = JSON.parse(JSON.stringify(self.autoship));
      
          updatedautoship.delivery_date = ymd;
          updatedautoship.address_id = address.id;
      
          self.$store.dispatch('updateAutoship', updatedautoship);
      
        },
        });
      
      
        //mutate date, but dont commit to server
      
      
      
      },700),

      changeDeliveryAddress: function(addressId){
        //pass selected address to calendar so that it can recalculate which days to show and which no
        this.activateCalendar(addressId)
      },
      /* end of calendar logic */

      removeItem: function(item) {
      
        this.$store.dispatch('removeAutoshipItem', item).then((response) => {
          this.$store.dispatch('loadAutoshipDetails', this.autoship.id);
        }).catch((error) => {
          console.error('Cart was not loaded')
        });
      },
      
      updateCartItemReturn: _.debounce(function(item, returnItems) {
        var updatedItem = JSON.parse(JSON.stringify(item)); //copy object
        updatedItem.return = returnItems;
        this.$store.dispatch('addAutoshipItem', [this.autoship.id, updatedItem]).then((response) => {
          this.$store.dispatch('loadAutoshipDetails', this.autoship.id);
        }).catch((error) => {
          console.error('Cart was not loaded')
        });
      
      }, 500),
      updateCartItemOrder: _.debounce(function(item, order) {
      
        if(order == "")  return; //this.removeItem(item)
        else {
          var updatedItem = JSON.parse(JSON.stringify(item)); //copy object
          updatedItem.order = order;
          if(item.isrentable == 1) updatedItem.return = order; //set that both numbers are same
      
          this.$store.dispatch('addAutoshipItem', [this.autoship.id, updatedItem]).then((response) => {
            this.$store.dispatch('loadAutoshipDetails', this.autoship.id);
          }).catch((error) => {
            console.error('Cart was not loaded')
          });
        }
      
      }, 500),

  }

}
</script>



// WEBPACK FOOTER //
// AutoshipEditPage.vue?7a7e54bc